var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.4729C40 34.3771 36.5706 36.8002 32.3416 36.8002C32.1701 36.8002 32 36.7958 31.8314 36.787C31.5316 36.7739 31.2362 36.7476 30.9469 36.7096C30.0847 36.5942 26.9431 36.0918 23.8165 36.1137C20.6884 36.1342 17.5767 36.6775 16.5519 36.7637C16.4251 36.7739 16.2968 36.7827 16.1671 36.7885C16 36.7958 15.8299 36.8002 15.6584 36.8002C11.4294 36.8002 8 34.3771 8 30.4729C8 28.8326 8.60712 27.3253 9.62297 26.1261C9.61402 25.9786 9.60806 25.8281 9.60806 25.6733C9.60806 25.3388 9.62297 24.9956 9.6543 24.6465C10.16 18.7895 14.9185 11.2002 24 11.2002C33.805 11.2002 37.9221 18.791 38.3532 24.648C38.38 24.9971 38.3919 25.3388 38.3919 25.6733C38.3919 25.8281 38.386 25.9786 38.377 26.1261C39.3929 27.3253 40 28.8326 40 30.4729Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.4729C40 34.3771 36.5706 36.8002 32.3416 36.8002C32.1701 36.8002 32 36.7958 31.8314 36.787C30.3084 35.4973 29.3463 33.5898 29.3463 31.4631C29.3463 27.575 32.5653 24.4216 36.5378 24.4216C37.1643 24.4216 37.7729 24.5005 38.3532 24.648C38.38 24.9971 38.3919 25.3388 38.3919 25.6733C38.3919 25.8281 38.386 25.9786 38.377 26.1261C39.3929 27.3253 40 28.8326 40 30.4729Z",
    fill: "#CDCDCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6537 31.4631C18.6537 33.5912 17.6901 35.4973 16.1671 36.7885C16 36.7958 15.8299 36.8002 15.6584 36.8002C11.4294 36.8002 8 34.3771 8 30.4729C8 28.8326 8.60712 27.3253 9.62297 26.1261C9.61402 25.9786 9.60806 25.8281 9.60806 25.6733C9.60806 25.3388 9.62297 24.9956 9.6543 24.6465C10.2316 24.499 10.8387 24.4216 11.4622 24.4216C15.4346 24.4216 18.6537 27.575 18.6537 31.4631Z",
    fill: "#CDCDCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6305 23.4997C28.6305 24.1453 28.0964 24.6682 27.4371 24.6682C26.7778 24.6682 26.2437 24.1453 26.2437 23.4997C26.2437 22.8541 26.7778 22.3312 27.4371 22.3312C28.0964 22.3312 28.6305 22.8541 28.6305 23.4997Z",
    fill: "#ADADAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7563 23.4997C21.7563 24.1453 21.2222 24.6682 20.5629 24.6682C19.9036 24.6682 19.3695 24.1453 19.3695 23.4997C19.3695 22.8541 19.9036 22.3312 20.5629 22.3312C21.2222 22.3312 21.7563 22.8541 21.7563 23.4997Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileS);
export default __webpack_public_path__ + "static/media/default_profile_S.93eccfbd723437bf270fcc906dd8309f.svg";
export { ForwardRef as ReactComponent };